<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_return_tab_month_item') }} </v-tab>
      <v-tab-item value="tab-1">
        <remove-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          @setAllMonth="setAllMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMonthItem="setMonthItem"
          @deleteMonthItem="deleteMonthItem"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import RemoveMonthSetting from '@/components/Quotation/MonthItem/RemoveMonthSetting.vue'
export default {
  components: { RemoveMonthSetting },
  name: 'RemoveCar',

  data: () => ({}),
  watch: {},
  methods: {
    setAllMonth (temp) {
      this.$emit('setAllMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMonthItem (val) {
      this.$emit('setMonthItem', val)
    },
    deleteMonthItem () {
      this.$emit('deleteMonthItem')
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'allPayQuantityType',
    'discountItemList'
  ]
}
</script>
